import { ThemeType } from '../../models/ThemeType';

// Action Types
export const SET_THEME = 'SET_THEME';
export const TOGGLE_THEME = 'TOGGLE_THEME';

// Action Creators
export const setTheme = (theme: ThemeType) => ({
  type: SET_THEME,
  payload: theme
});

export const toggleTheme = () => ({
  type: TOGGLE_THEME
}); 